export default __webpack_public_path__ + "static/media/img_muslinTwoEars_rg_p.ca72134f.jpg";